import { useTranslation } from "react-i18next";
import BtnCustom from "components/common/btn-custom";
import { ErrorToaster } from "components/common/toast";
import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  Form,
  Row,
  Col,
} from "reactstrap";
import { successToaster } from "components/common/toast";
import { editUserAPI } from "network/user";
import defaultProfile from "assets/img/user_img.png";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { DeleteUserAPI } from "network/user";
import { useLogout } from "utils/logout";
import handleError from "utils/handleError";
import CustomInputField from "components/common/CustomInputField";
import CicSettings from "components/cic-setting/CicSettings";
import { UserContextProvider } from "context/UserContext";
import { UserProfileSchema } from "components/schema/UserProfileSchema";

const UserProfile = () => {
  const { t } = useTranslation("account");
  const { user, fetchUser } = useContext(UserContextProvider);
  const [error, setError] = useState("");
  const [alert, setAlert] = useState(null);
  const logout = useLogout();
  const [imagePreview, setImagePreview] = useState();

  useEffect(() => {
    setImagePreview(
      user?.profile_url
        ? `${process.env.REACT_APP_BASE_URL}${user.profile_url}`
        : defaultProfile
    );
  }, [user]);
  // useEffect(() => {
  //   setImagePreview(
  //     user?.profile_url
  //       ? `${process.env.REACT_APP_BASE_URL}${user.profile_url}?t=${Date.now()}`
  //       : defaultProfile
  //   );
  // }, [user]);

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,

    isSubmitting,
  } = useFormik({
    initialValues: {
      firstName: user?.first_name || "",
      lastName: user?.last_name || "",
      email: user?.email || "",
      phone: user?.phone_number || "",
    },
    enableReinitialize: true,
    validationSchema: UserProfileSchema,
    onSubmit: async (values) => {
      try {
        const formData = new FormData();

        formData.append("first_name", values.firstName);
        formData.append("last_name", values.lastName);
        formData.append("phone_number", values.phone);

        if (values.profile) {
          formData.append("file ", values.profile);
        }

        const response = await editUserAPI(formData);
        if (response.success) {
          successToaster(t("profile.updated"));
          fetchUser();
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!validTypes.includes(file.type)) {
      setError(t("profile.invalidFormat"));
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      setError(t("profile.tooBig"));
      return;
    }

    setError("");

    setImagePreview(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append("profile_url", file);

    try {
      const response = await editUserAPI(formData);
      if (response.success) {
        fetchUser();
        successToaster(t("profile.updated"));
      }
    } catch (error) {
      ErrorToaster(handleError(error?.status_code, error?.message));
      setImagePreview(user?.profile_url || defaultProfile);
    }
  };

  const warningWithConfirmMessage = () => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("profile.confirmTitle")}
        onConfirm={() => successDelete()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("profile.confirmYes")}
        cancelBtnText={t("profile.cancel")}
        showCancel
        btnSize=""
      >
        {t("profile.confirmText")}
      </ReactBSAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  const successDelete = async () => {
    try {
      const response = await DeleteUserAPI();

      if (response.success) {
        successToaster(t("profile.deleted"));
        logout();
      } else {
        ErrorToaster(t("profile.deleteFailed"));
      }
    } catch (error) {
      ErrorToaster(t("profile.deleteFailed"));
    }
  };

  return (
    <>
      <div className="content">
        {alert}
        <Row>
          <Col lg="8">
            <Card>
              <CardHeader>
                <h3 className="title text-capitalize">{t("profile.editTitle")}</h3>
              </CardHeader>
              <Form onSubmit={handleSubmit}>
                <CardBody>
                  <Row>
                    <Col className="pr-md-1" md="6">
                      <CustomInputField
                        label={t("profile.firstName")}
                        name="firstName"
                        placeholder={t("profile.firstName")}
                        type="text"
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                      />
                    </Col>
                    <Col className="px-md-1" md="6">
                      <CustomInputField
                        label={t("profile.lastName")}
                        name="lastName"
                        placeholder={t("profile.lastName")}
                        type="text"
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-md-1" md="6">
                      <CustomInputField
                        label={t("profile.phone")}
                        name="phone"
                        placeholder={t("profile.phone")}
                        type="text"
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                      />
                    </Col>
                    <Col className="px-md-1" md="6">
                      <CustomInputField
                        label={t("profile.email")}
                        name="email"
                        placeholder={t("profile.email")}
                        type="email"
                        disabled={true}
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                      />
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <BtnCustom
                    className="btn-fill"
                    color="primary"
                    type="submit"
                    submittingText={t("profile.saving")}
                    isLoading={isSubmitting}
                  >
                    {t("profile.save")}
                  </BtnCustom>
                </CardFooter>
              </Form>
            </Card>
            {user?.role?.toLowerCase() === "user" ||
            user?.role?.toLowerCase() === "reseller" ? (
              <CicSettings />
            ) : null}
          </Col>
          <Col md="4">
            <Card className="card-user">
              <CardBody>
                <CardText />
                <div className="author">
                  <div className="block block-one" />
                  <div className="block block-two" />
                  <div className="block block-three" />
                  <div className="block block-four" />
                  <div className="author">
                    <div className="profile-img-wrapper">
                      <label htmlFor="file-input" className="edit-icon pointer">
                        <img
                          alt={t("profile.avatarAlt")}
                          className="avatar"
                          src={imagePreview}
                        />
                      </label>
                      {error && (
                        <span className="error text-danger d-block text-center">
                          {error}
                        </span>
                      )}

                      <input
                        id="file-input"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                  {user?.first_name && (
                    <h3 className="title text-capitalize mb-2">
                      {user?.first_name + " " + user?.last_name}
                    </h3>
                  )}
                  {user?.role && (
                    <p className="description text-capitalize">
                      {user?.role?.replace(/_/g, " ")}
                    </p>
                  )}
                </div>
              </CardBody>
              <CardFooter>
                {/* <div className="button-container">
                  <Button className="btn-icon btn-round" color="facebook">
                    <i className="fab fa-facebook" />
                  </Button>
                  <Button className="btn-icon btn-round" color="twitter">
                    <i className="fab fa-twitter" />
                  </Button>
                  <Button className="btn-icon btn-round" color="google">
                    <i className="fab fa-google-plus" />
                  </Button>
                </div> */}
                <div className="button-container d-flex justify-content-center">
                  <Button
                    className="text-capitalize"
                    block
                    color="danger"
                    onClick={() => warningWithConfirmMessage()}
                  >
                    {t("profile.deleteAccount")}
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserProfile;
